const state = () => ({
    _currentInlineEdit: null,
});

const getters = {
    currentInlineEdit: (state) => state._currentInlineEdit,
};

const actions = {
    setCurrentInlineEdit(id) {
        this._setFormCurrentInlineEditSet(id);
    },

    clearCurrentInlineEdit() {
        this._setFormCurrentInlineEditCleared();
    },

    // Private methods
    /**
     * Sets the current inline edit element.
     *
     * @param {Number} id
     * @return {void}
     */
    _setFormCurrentInlineEditSet(id) {
        this._currentInlineEdit = id;
    },

    /**
     * Clears the current inline edit element.
     *
     * @return {void}
     */
    _setFormCurrentInlineEditCleared() {
        this._currentInlineEdit = null;
    },
};

export default {
    state,
    getters,
    actions,
};
